const STORAGE_KEY = 'cipherSettings';

const truthy = (value) => {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    return ['true', '1', 'yes', 'y', 'on'].includes(normalized);
  }
  return Boolean(value);
};

const normalizeOverrides = (value) => {
  if (!value || typeof value !== 'object') {
    return {};
  }
  return Object.entries(value).reduce((acc, [term, flag]) => {
    if (!term) return acc;
    acc[term.toLowerCase()] = truthy(flag);
    return acc;
  }, {});
};

export const DEFAULT_SETTINGS = {
  enableRealtimeCorrections: true,
  enableAutoExpand: true,
  enableAiStreaming: false,
  showConfidenceScores: true,
  defaultMode: 'realtime',
  autoExpandOverrides: {},
  sttProvider: 'speechmatics',
  lastMeetingProvider: 'speechmatics',
  lastMeetingModel: '',
  lastMeetingTemplate: '',
  lastMeetingLanguage: 'en-GB',
};

export const mergeSettings = (partial = {}) => {
  const merged = {
    ...DEFAULT_SETTINGS,
    ...partial,
  };

  merged.enableRealtimeCorrections = truthy(merged.enableRealtimeCorrections);
  merged.enableAutoExpand = truthy(merged.enableAutoExpand);
  merged.enableAiStreaming = truthy(merged.enableAiStreaming);
  merged.showConfidenceScores = truthy(merged.showConfidenceScores);
  merged.defaultMode =
    typeof merged.defaultMode === 'string' ? merged.defaultMode : DEFAULT_SETTINGS.defaultMode;
  merged.autoExpandOverrides = normalizeOverrides(partial.autoExpandOverrides || merged.autoExpandOverrides);
  merged.sttProvider =
    typeof merged.sttProvider === 'string'
      ? merged.sttProvider.trim().toLowerCase() || DEFAULT_SETTINGS.sttProvider
      : DEFAULT_SETTINGS.sttProvider;
  merged.lastMeetingProvider =
    typeof merged.lastMeetingProvider === 'string'
      ? merged.lastMeetingProvider.trim() || DEFAULT_SETTINGS.lastMeetingProvider
      : DEFAULT_SETTINGS.lastMeetingProvider;
  merged.lastMeetingModel =
    typeof merged.lastMeetingModel === 'string'
      ? merged.lastMeetingModel.trim()
      : DEFAULT_SETTINGS.lastMeetingModel;
  merged.lastMeetingTemplate =
    typeof merged.lastMeetingTemplate === 'string'
      ? merged.lastMeetingTemplate.trim()
      : DEFAULT_SETTINGS.lastMeetingTemplate;
  merged.lastMeetingLanguage =
    typeof merged.lastMeetingLanguage === 'string'
      ? merged.lastMeetingLanguage.trim() || DEFAULT_SETTINGS.lastMeetingLanguage
      : DEFAULT_SETTINGS.lastMeetingLanguage;

  return merged;
};

export const loadSettings = () => {
  if (typeof window === 'undefined') {
    return { ...DEFAULT_SETTINGS };
  }

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return { ...DEFAULT_SETTINGS };
    }
    const parsed = JSON.parse(raw);
    return mergeSettings(parsed);
  } catch (error) {
    console.warn('Failed to load settings from storage:', error);
    return { ...DEFAULT_SETTINGS };
  }
};

export const persistSettings = (settings) => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    const merged = mergeSettings(settings);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
  } catch (error) {
    console.error('Failed to persist settings:', error);
  }
};
